module.exports = __webpack_public_path__ + "static/img/2.9b8b8b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/2.jpg
// module id = Em0o
// module chunks = 1